import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, Row, Col, Typography, Spin, Tag, Image } from 'antd';
import Animate from 'rc-animate';
import TimeAgo from 'react-timeago'
import { useHistory, useLocation } from 'react-router-dom'
import instance from '../../utils/API';
import logofull from '../../assets/logo.png'

const { Title } = Typography;

const { Meta } = Card;

const Articles = () => {
    const user = useSelector(state => state.user)
    const history = useHistory()
    const location = useLocation()

    const articleType = location.pathname.replace('/', '')


    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const loadArticles = () => {
        setLoading(true)

        let typeParam = ""
        switch (articleType) {
            case "news":
                typeParam = "news"
                break;
            case "chart-breakdowns":
                typeParam = "chartBreakdowns"
                break;
            case "psychology-mindset":
                typeParam = "psychology"
                break;
            default:
                break;
        }
        instance(user.jwt).get("/articles?type="+ typeParam + "&_sort=publishAt:desc")
            .then(function (response) {
                setArticles(response.data)
                setLoading(false);
            })
            .catch(function (error) {
                setError(true);
                setLoading(false);
            })
    }

    const pageTitle = () =>{
        switch (articleType) {
            case "news":
                return "Market News"
            case "chart-breakdowns":
                return "Chart Breakdowns"
            case "psychology-mindset":
                return "Psychology & Mindset"
            default:
                break;
        }
    }

    useEffect(() => {
            pageTitle()
            loadArticles()
    }, [articleType]);

    const onArticleClick =(slug)=>{
        history.push("/article/"+slug);
    }

    if(loading) {
        return (
        <>
        <Row>
            <Title level={2}>
                {pageTitle()}
            </Title>
        </Row>
        <Row justify="center">
                <Col>
                    <Spin
                        size="large"
                        spinning={loading}
                        delay={100}
                    ></Spin>
                </Col>
        </Row>
        </>
        )
    }

    return (
        <>
        <Row>
            <Title level={2}>
                {pageTitle()}
            </Title>
        </Row>
        <Row gutter={[24, 24]}>

            {articles.map((item)=>(
            <Col xs={24} sm={12} md={12} lg={10} xl={8}  key={item.id}> 
            <Animate
                    transitionName="fade"
                    transitionAppear
                >
                <Card hoverable
                    key={item.id}
                    bordered
                    cover={
                        <Image
                            loading="lazy"
                            src={item.photoUrl && item.photoUrl.url}
                            alt={logofull}
                        />
                    }
                    onClick={() => {onArticleClick(item.slug)}}
                >
                <Meta
                  title={item.title}
                  description={
                            <>
                                <TimeAgo date={item.publishAt} />
                                        <Tag 
                                        hidden={!item.membersOnly}
                                        style={{
                                            float:"right", 
                                            borderRadius: 5
                                        }} 
                                        color="green">Members Only</Tag>
                                
                            </>
                            }
                  style={{whiteSpace:"unset"}}
                />
                
                </Card>
            </Animate>
            </Col>
            ))}
        </Row>
        </>
    )
}

export default Articles
